/**
 * Screencastify - Screen Video Recorder
 *
 * 82 static resources exposed to every origin, including the webcam overlay UI.
 * Manifest verified against version 4.24.2.5527.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'mmeijimgabbpbgpdklnllpncmdofkcpn';
export const screencastify: ExtensionDefinition = {
  id: ID,
  name: 'Screencastify - Screen Video Recorder',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 4_000_000,
  notes:
    'A screen recorder being remotely enumerable is worth noting — it tells a site the ' +
    'visitor has recording capability installed.',
  signals: [
    { id: 'war-webcam-html', kind: 'web-accessible-resource',
      description: 'Fetch webcam.html — the webcam overlay injected during recording.',
      weight: 1, run: () => probeFetch(ID, 'webcam.html') },
    { id: 'war-controller-html', kind: 'web-accessible-resource',
      description: 'Fetch controller.html — the in-page recording controls.',
      weight: 0.5, run: () => probeFetch(ID, 'controller.html') },
  ],
};
